"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
function LeftThin(props) {
    return (react_1.default.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
        react_1.default.createElement("polygon", { fill: "currentColor", points: "2.552 1.748 2.552 9.248 10.052 9.248 10.052 10.248 1.552 10.248 1.552 1.748", transform: "scale(1 -1) rotate(45 24.696 3.828)" })));
}
exports.default = LeftThin;
//# sourceMappingURL=LeftThin.js.map